export default "__VITE_ASSET__Dr6YjrHq__"